import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { createTmOptions as N } from "../../select/src/utils.js";
import { popselectInjectionKey as T } from "./interface.js";
import S from "./styles/index.cssr.js";
import k from "../../_mixins/use-config.js";
import V from "../../_mixins/use-theme.js";
import _ from "../styles/light.js";
import { createTreeMate as x } from "../../../../../../treemate@0.3.11/node_modules/treemate/es/create.js";
import { useThemeClass as R } from "../../_mixins/use-css-vars-class.js";
import U from "../../_internal/select-menu/src/SelectMenu.js";
import { warn as A } from "../../_utils/naive/warn.js";
import { happensIn as m } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/dom/happens-in.js";
import { call as d } from "../../_utils/vue/call.js";
import { keysOf as F } from "../../_utils/vue/keysOf.js";
import { defineComponent as B, watchEffect as O, inject as I, computed as g, watch as E, nextTick as y, h as L } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { toRef as $ } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const w = {
  multiple: Boolean,
  value: {
    type: [String, Number, Array],
    default: null
  },
  cancelable: Boolean,
  options: {
    type: Array,
    default: () => []
  },
  size: {
    type: String,
    default: "medium"
  },
  scrollable: Boolean,
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  onMouseenter: Function,
  onMouseleave: Function,
  renderLabel: Function,
  showCheckmark: {
    type: Boolean,
    default: void 0
  },
  nodeProps: Function,
  virtualScroll: Boolean,
  // deprecated
  onChange: [Function, Array]
}, ne = F(w), se = B({
  name: "PopselectPanel",
  props: w,
  setup(t) {
    process.env.NODE_ENV !== "production" && O(() => {
      t.onChange !== void 0 && A("popselect", "`on-change` is deprecated, please use `on-update:value` instead.");
    });
    const o = I(T), {
      mergedClsPrefixRef: n,
      inlineThemeDisabled: h
    } = k(t), M = V("Popselect", "-pop-select", S, _, o.props, n), f = g(() => x(t.options, N("value", "children")));
    function u(e, l) {
      const {
        onUpdateValue: s,
        "onUpdate:value": r,
        onChange: i
      } = t;
      s && d(s, e, l), r && d(r, e, l), i && d(i, e, l);
    }
    function P(e) {
      b(e.key);
    }
    function C(e) {
      !m(e, "action") && !m(e, "empty") && !m(e, "header") && e.preventDefault();
    }
    function b(e) {
      const {
        value: {
          getNode: l
        }
      } = f;
      if (t.multiple)
        if (Array.isArray(t.value)) {
          const s = [], r = [];
          let i = !0;
          t.value.forEach((v) => {
            if (v === e) {
              i = !1;
              return;
            }
            const c = l(v);
            c && (s.push(c.key), r.push(c.rawNode));
          }), i && (s.push(e), r.push(l(e).rawNode)), u(s, r);
        } else {
          const s = l(e);
          s && u([e], [s.rawNode]);
        }
      else if (t.value === e && t.cancelable)
        u(null, null);
      else {
        const s = l(e);
        s && u(e, s.rawNode);
        const {
          "onUpdate:show": r,
          onUpdateShow: i
        } = o.props;
        r && d(r, !1), i && d(i, !1), o.setShow(!1);
      }
      y(() => {
        o.syncPosition();
      });
    }
    E($(t, "options"), () => {
      y(() => {
        o.syncPosition();
      });
    });
    const p = g(() => {
      const {
        self: {
          menuBoxShadow: e
        }
      } = M.value;
      return {
        "--n-menu-box-shadow": e
      };
    }), a = h ? R("select", void 0, p, o.props) : void 0;
    return {
      mergedTheme: o.mergedThemeRef,
      mergedClsPrefix: n,
      treeMate: f,
      handleToggle: P,
      handleMenuMousedown: C,
      cssVars: h ? void 0 : p,
      themeClass: a == null ? void 0 : a.themeClass,
      onRender: a == null ? void 0 : a.onRender
    };
  },
  render() {
    var t;
    return (t = this.onRender) === null || t === void 0 || t.call(this), L(U, {
      clsPrefix: this.mergedClsPrefix,
      focusable: !0,
      nodeProps: this.nodeProps,
      class: [`${this.mergedClsPrefix}-popselect-menu`, this.themeClass],
      style: this.cssVars,
      theme: this.mergedTheme.peers.InternalSelectMenu,
      themeOverrides: this.mergedTheme.peerOverrides.InternalSelectMenu,
      multiple: this.multiple,
      treeMate: this.treeMate,
      size: this.size,
      value: this.value,
      virtualScroll: this.virtualScroll,
      scrollable: this.scrollable,
      renderLabel: this.renderLabel,
      onToggle: this.handleToggle,
      onMouseenter: this.onMouseenter,
      onMouseleave: this.onMouseenter,
      onMousedown: this.handleMenuMousedown,
      showCheckmark: this.showCheckmark
    }, {
      header: () => {
        var o, n;
        return ((n = (o = this.$slots).header) === null || n === void 0 ? void 0 : n.call(o)) || [];
      },
      action: () => {
        var o, n;
        return ((n = (o = this.$slots).action) === null || n === void 0 ? void 0 : n.call(o)) || [];
      },
      empty: () => {
        var o, n;
        return ((n = (o = this.$slots).empty) === null || n === void 0 ? void 0 : n.call(o)) || [];
      }
    });
  }
});
export {
  se as default,
  ne as panelPropKeys,
  w as panelProps
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/popselect/src/PopselectPanel.js
// module id = 1683
// module chunks = 41